import { render } from "./IOTPatients.vue?vue&type=template&id=e3151610&scoped=true"
import script from "./IOTPatients.js?vue&type=script&lang=js"
export * from "./IOTPatients.js?vue&type=script&lang=js"

import "./IOTPatients.vue?vue&type=style&index=0&id=e3151610&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3151610"]])

export default __exports__